import color from "../../../constants/color";

const style = {
  container: {
    px: "15px",
    py: 2,
    backgroundColor: "#F1F1F1",
    minHeight: "100vh",
  },
  headerContainer: {
    mb: 2,
  },
  title: {
    fontWeight: 600,
    fontSize: "24px",
    color: color.text,
    mb: 0.5,
  },
  subtitle: {
    fontSize: "14px",
    color: color.lightText,
  },
  section: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    p: 3,
    mb: 2,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: "16px",
    color: color.text,
    mb: 2,
  },
  modulesHeader: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    pb: 1.5,
    mb: 2,
    borderBottom: "1px solid #E6E6E6",
  },
  moduleRow: {
    display: "grid",
    gridTemplateColumns: "2fr 3fr 7fr",
    columnGap: "24px",
    alignItems: "center",
    padding: "12px 0",
    "@media (max-width: 1200px)": {
      gridTemplateColumns: "2fr 3fr 7fr",
    },
    "@media (max-width: 900px)": {
      gridTemplateColumns: "1fr",
      rowGap: "12px",
      alignItems: "flex-start",
    },
  },
  moduleLabel: {
    gridColumn: "1",
    fontSize: "13px",
    fontWeight: 600,
    color: color.text,
  },
  moduleSwitch: {
    gridColumn: "2",
    display: "flex",
    justifyContent: "center",
    "@media (max-width: 900px)": {
      gridColumn: "1",
      justifyContent: "flex-end",
    },
  },
  moduleSwitchPlaceholder: {
    width: 28,
    height: 16,
  },
  moduleFields: {
    gridColumn: "3",
    marginTop: 0,
    width: "100%",
    "@media (max-width: 900px)": {
      gridColumn: "1",
    },
  },
  usersConfigRow: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap",
  },
  radioGroup: {
    display: "flex",
    gap: "16px",
  },
  radioGroupFull: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  radio: {
    color: `${color.primary} !important`,
    "&.Mui-checked": {
      color: `${color.primary} !important`,
    },
  },
  radioLabel: {
    fontSize: "13px",
    color: color.text,
  },
  usersInput: {
    flex: 1,
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "& fieldset": {
        borderColor: "#DDDDDD",
      },
      "&:hover fieldset": {
        borderColor: color.text,
      },
      "&.Mui-focused fieldset": {
        borderColor: color.primary,
      },
      "&.Mui-error fieldset": {
        borderColor: "#d32f2f",
      },
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      padding: "10px 14px",
    },
    "& .MuiFormHelperText-root": {
      fontSize: "12px",
    },
  },
  input: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "& fieldset": {
        borderColor: "#DDDDDD",
      },
      "&:hover fieldset": {
        borderColor: color.text,
      },
      "&.Mui-focused fieldset": {
        borderColor: color.primary,
      },
      "&.Mui-error fieldset": {
        borderColor: "#d32f2f",
      },
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      padding: "10px 14px",
    },
    "& .MuiFormHelperText-root": {
      fontSize: "12px",
    },
  },
  select: {
    borderRadius: "8px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#DDDDDD",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: color.text,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: color.primary,
    },
    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "#d32f2f",
    },
    "& .MuiSelect-select": {
      fontSize: "14px",
      padding: "10px 14px",
    },
  },
  errorText: {
    fontSize: "12px",
    color: color.red,
    mt: 0.5,
    ml: 1.75,
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 2,
    mt: 3,
    flexWrap: "wrap",
  },
  submitButton: {
    backgroundColor: color.primary,
    color: "#fff",
    borderRadius: "50px",
    textTransform: "none",
    px: 4,
    py: 1,
    fontWeight: 500,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: "#228A3A",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    },
    "&:disabled": {
      backgroundColor: "#D3D3D3",
      color: "#9E9E9E",
      cursor: "not-allowed",
    },
  },
  cancelButton: {
    backgroundColor: "#9E9E9E",
    color: "#fff",
    borderRadius: "50px",
    textTransform: "none",
    px: 4,
    py: 1,
    fontWeight: 500,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: "#757575",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    },
  },
};

export default style;
